import { createAuthClient } from 'better-auth/react';
import { inferAdditionalFields } from 'better-auth/client/plugins';

// Better Auth's React client passes baseURL straight to `new URL(...)`, which
// rejects relative paths. Resolve against the current origin so the same
// build works on localhost:4200 (Vite proxy → API) and on the prod domain.
export const authClient = createAuthClient({
  baseURL: `${window.location.origin}/api/auth`,
  plugins: [
    inferAdditionalFields({
      user: {
        locale: { type: 'string', required: false },
        introCompleted: { type: 'boolean', required: false, defaultValue: false },
        // Write-only: the pre-auth draft passed to signUp.email so the API can
        // persist coach/covenant/ritual server-side (email signup has no session
        // to POST /me/claim). Consumed + nulled by the API's create hook.
        pendingClaim: { type: 'string', required: false },
      },
    }),
  ],
});

export const { signUp, signIn, signOut, useSession, sendVerificationEmail } = authClient;
